export default __webpack_public_path__ + "static/media/new-york.c1c71e47.png";